import { getRgObjectsOfType as f, RG_TYPE as s } from "@project-rouge/rg-core";
import { getPolygonPerimeter as m } from "../../../geometry-utils/core/index16.js";
import { getLevelCount as u } from "../../object-helpers/index3.js";
const P = (n) => {
  let t = 0;
  const l = f(n, s.Building), r = u(l, !1);
  for (const i of l)
    for (let o = 0; o < r; o++) {
      const g = i.data.levels.filter((e) => e.levelIndex === o);
      for (const e of g)
        !e.geaPolygon || (t += m(e.geaPolygon));
    }
  return t;
};
export {
  P as getSumExternalWallPerimeter
};
//# sourceMappingURL=index57.js.map
